import React, { useMemo } from 'react';
import moment from 'moment';
export const TimeFilter: React.ComponentType<{
  onChange: (values: string[]) => void;
  value?: any[];
}> = ({ onChange, value = [] }) => {
  const date = useMemo(() => {
    return value[0] ? moment(value[0], 'HH:mm').toDate() : undefined;
  }, [value]);

  return (
    <>

    </>
  );
};
